export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_consulting.7004428.svg";